"use strict";
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunityMandateDetailsDocumentMap = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const opportunity_mandate_details_entry_entity_1 = require("./opportunity-mandate-details-entry.entity");
const file_upload_entity_1 = require("./file-upload.entity");
const look_up_entity_1 = require("./look-up.entity");
let OpportunityMandateDetailsDocumentMap = class OpportunityMandateDetailsDocumentMap {
};
exports.OpportunityMandateDetailsDocumentMap = OpportunityMandateDetailsDocumentMap;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], OpportunityMandateDetailsDocumentMap.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "mandate_id" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityMandateDetailsDocumentMap.prototype, "mandateId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "document_type_lid" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityMandateDetailsDocumentMap.prototype, "documentTypeLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "document_id" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityMandateDetailsDocumentMap.prototype, "documentId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "document_type_lid" }),
    tslib_1.__metadata("design:type", typeof (_a = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _a : Object)
], OpportunityMandateDetailsDocumentMap.prototype, "documentType", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => opportunity_mandate_details_entry_entity_1.OpportunityMandateDetailsEntry, (mandate) => mandate.mandateDetailsDocuments, { onDelete: "CASCADE" }),
    (0, typeorm_1.JoinColumn)({ name: "mandate_id" }),
    tslib_1.__metadata("design:type", typeof (_b = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _b : Object)
], OpportunityMandateDetailsDocumentMap.prototype, "mandate", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => file_upload_entity_1.FileUpload),
    (0, typeorm_1.JoinColumn)({ name: "document_id" }),
    tslib_1.__metadata("design:type", typeof (_c = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _c : Object)
], OpportunityMandateDetailsDocumentMap.prototype, "document", void 0);
exports.OpportunityMandateDetailsDocumentMap = OpportunityMandateDetailsDocumentMap = tslib_1.__decorate([
    (0, typeorm_1.Entity)("opportunity_mandate_details_document_map")
], OpportunityMandateDetailsDocumentMap);
